import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { CompanyAccess } from 'src/model/companyAccess.model';
import { User } from 'src/model/user.model';
import { AdminAccessService } from 'src/services/admin-access.service';
import { UserService } from 'src/services/user.service';

@Component({
    selector: 'app-manage-company-access',
    templateUrl: './manage-company-access.component.html',
    styleUrls: ['./manage-company-access.component.scss'],
    standalone: false
})
export class ManageCompanyAccessComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private enums = inject(Enums);
  private cdr = inject(ChangeDetectorRef);
  private userService = inject(UserService);
  private adminAccessService = inject(AdminAccessService);


  userList: User[] = [];
  selectedUser: string;
  priority: number;

  companyAccessList: CompanyAccess[] = [];

  @Input() selectedCompany: number;
  @Input() selectedCompanyCode: number;

  ngOnInit(): void {
    this.getAllUsersByRoles();
    this.getCompanyAccess(this.selectedCompany);
  }

  async getAllUsersByRoles() {
    this.userList = await this.userService.getAllUsers({ roleId: [this.enums.ADMIN, this.enums.EXPENSE_ADMIN, this.enums.AUDITOR] });
  }

  async getCompanyAccess(companyId: number) {
    this.companyAccessList = await this.adminAccessService.getCompaniesAccess(companyId);
  }

  submit() {
    if (this.selectedUser == undefined || this.priority == undefined || this.priority == 0) {
      this.sharedService.openAlert("Please fill in all necessary info", ALERT_TYPE.DANGER);
    } else {
      this.grantUserCompanyAccess();
    }
  }

  async grantUserCompanyAccess() {
    const granted = await this.adminAccessService.putGrantAccessRequest(this.selectedUser, this.priority, [this.selectedCompany]);
    if (granted.companyIds.length > 0) {
      this.sharedService.openAlert("Successfully granted access to user!", ALERT_TYPE.SUCCESS);
      const access = new CompanyAccess(undefined, this.selectedCompany, this.priority, this.selectedUser);
      this.companyAccessList.push(access);
      this.cdr.detectChanges();
      this.reset();
    }
  }

  confirmBeforeRevoke(username: string, index: number) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Confirm to revoke " + username + "'s access from company?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.revokeUserCompanyAccess(username, index);
    });
  }

  async revokeUserCompanyAccess(username: string, index: number) {
    const revoked = await this.adminAccessService.revokeAccess(username, [this.selectedCompany]);
    if (revoked.companyIds.length > 0) {
      this.sharedService.openAlert("Successfully revoked access from user!", ALERT_TYPE.SUCCESS);
      this.companyAccessList.splice(index, 1);
      this.cdr.detectChanges();
      this.reset();
    }
  }

  reset() {
    this.priority = undefined;
    this.selectedUser = undefined;
  }

  close() {
    this.activeModal.close();
  }
}
